import { render, staticRenderFns } from "./E31W.vue?vue&type=template&id=b061977a&scoped=true&"
import script from "./E31W.vue?vue&type=script&lang=js&"
export * from "./E31W.vue?vue&type=script&lang=js&"
import style0 from "./E31W.vue?vue&type=style&index=0&id=b061977a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b061977a",
  null
  
)

export default component.exports